<template>
  <div>
    <!-- <div class="progress-box" v-if="progress!==100">
      <el-progress type="circle" :percentage="progress"></el-progress>
    </div>-->

    <div>

      <el-button type="success" size="mini" class="addkeywordButton" @click="isShowAddDialog=true" :disabled="addButtonIsDisable">添加关键词</el-button>
      <el-button type="primary" size="mini" style="float:right;margin-right: 8px;" @click="editData" v-if="!isShowSaveData">修改数据</el-button>
      <el-button type="primary" size="mini" style="float:right;margin-right: 8px;" @click="cancel" v-if="isShowSaveData">取消</el-button>
      <el-button type="primary" size="mini" style="float:right" @click="saveData" v-if="isShowSaveData">保存修改</el-button>
      <!-- <el-button type="primary" size="mini" style="float:right;margin-right: 8px;" @click="easyInputDialogVisible=true">导入</el-button> -->
      <!-- <el-dropdown split-button size="mini" type="primary" style="float:right;margin-right: 8px;" @command="handleCommand">
        导入
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="easy_input">简单导入</el-dropdown-item>
          <el-dropdown-item>文本分词后导入</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <div>

      <el-table @row-click="rowClick" :data="list" border style="width: 98%;font-size:12px" v-if="progress===100" max-height="560">
        <!-- <el-table-column prop="word" label="关键词"></el-table-column>
        <el-table-column prop="dataCount" label="近期媒体出现次数" width="180"></el-table-column>-->
        <el-table-column label="关键词">
          <template slot-scope="scope">
            <el-input placeholder="请输入内容" v-show="show" v-model="scope.row.word" size="mini" @blur="tableInputtBlur(scope.row.word)"></el-input>
            <span v-show="!show">{{scope.row.word}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="type=='yuliao'?'近期媒体出现次数':'历史共同出现次数'">
          <template slot-scope="scope">

            <el-input :placeholder="type=='yuliao'?'请输入近期媒体出现次数':'请输入历史共同出现次数'" v-show="show" v-model="scope.row.dataCount" size="mini" style="width:150px" @blur="tableInputtBlur(scope.row.dataCount)" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            <span v-show="!show">{{scope.row.dataCount}}</span>

            <i class="el-icon-circle-close" style="margin-left:5px;color:red;font-size:18px;" v-if="isShowSaveData" @click="deleteRow(scope.$index,list)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="添加关键词" :visible.sync="isShowAddDialog" width="500px" :close-on-click-modal="false" class="addDailogClass">
      <div style="border-top: 1px solid rgb(221, 221, 221);margin-bottom:20px"></div>
      <el-form label-position="left" label-width="128px">
        <el-form-item label="关键词:">
          <el-input placeholder="请输入词频关键词" v-model="word"></el-input>
        </el-form-item>
        <el-form-item :label="type=='yuliao'?'近期媒体出现次数:':'历史共同出现次数:'">

          <el-input :placeholder="type=='yuliao'?'请输入近期媒体出现次数':'请输入历史共同出现次数'" v-model="dataCount" :min="1" type="number"></el-input>
        </el-form-item>
      </el-form>
      <div style="border-top: 1px solid rgb(221, 221, 221);margin-top:-10"></div>
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" @click="addData">确认添加</el-button>
        <el-button @click="isShowAddDialog=false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="简单使用" :visible.sync="easyInputDialogVisible" id="easyInput" center :close-on-click-modal="true">
      <el-row style="margin-bottom:10px">
        <el-col :span="24">
          <label>您可以将多个词语输入到下面的文本框中，词与词之间用换行分隔，词与词频用空格分隔</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <textarea name="message" style="border:1px solid #cacaca;width:100%;height:400px;resize:none" v-model="textareaData"></textarea>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="4">
          <el-checkbox v-model="checked">去重</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="checked">删除数字</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="checked">过滤助词</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="checked">过滤介词</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="checked">过滤连词</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="checked">过滤代词</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="checked">覆盖旧的词频</el-checkbox>
        </el-col>
      </el-row> -->
      <el-row class="button-row">
        <el-button type="primary" @click="easyInputBtnClick">生成并使用</el-button>
        <el-button type="info" @click="easyInputDialogVisible = false">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Utils from "../../assets/script/utils/util.js";
import config from "../../assets/script/config";

export default {
  props: ["keyword", "type"],
  // inject:['showLoading'],
  data() {
    return {
      list: [],
      baklist: "",
      frequencyTimeout: null,
      easyInputDialogVisible: false,
      progress: 0,
      show: false,
      isShowAddDialog: false,
      word: "",
      dataCount: 1,
      isShowSaveData: false,
      isCanSave: true,
      addButtonIsDisable: false,
      gettime: null,
      textareaData: ''
    };
  },
  watch: {
    //点开编辑后初始化云图生成变量
    isShowSaveData(val) {
      if (val) {
        this.$emit("editwords", false);
      }
    },
    isShowAddDialog(val) {
      if (val) {
        this.$emit("editwords", false);
      }
    }
  },
  created() {
    let _this = this;
    Utils.$on("insertTask", function () {
      _this.insertTask();
    });
  },
  mounted() {

  },
  methods: {
    rowClick(row) {
      // 下拉框类型naotu / yuliao
      var selectType = this.type;
      //搜索的关键词
      var keyword = this.keyword;
      if (!this.isShowSaveData) {
        // 如果是近期热点
        if (selectType == "yuliao") {
          let url = config.clickSkip2SuCaiUrl + keyword + " " + row.word;
          window.open(url);
        } else {
          //如果是历史数据
          let url = config.clickSkip2ChangWeiCiUrl + (keyword + " " + row.word).encodeUnicode();
          window.open(url);
        }
      }
    },
    easyInputBtnClick() {

    },
    handleCommand(command) {
      if (command == "easy_input") {
        this.easyInputDialogVisible = true;
        let vv = 'test 1'
        this.textareaData = vv;
        // console.log(this.list);
      }
    },


    ...mapActions("core", ["AGetWordFrequencyList", "AInsert", "AFrequency"]),
    async insertTask(keyword, type) {
      //   this.showLoading(true,0);

      //先清空计时器
      this.gettime !== null && clearInterval(this.gettime);

      let timenum = 0;
      this.gettime = setInterval(() => {
        this.$emit("showLoading", { status: true, prop: timenum });
        timenum += 1;
        if (timenum > 99) {
          clearInterval(this.gettime);
        }
      }, 151);

      this.list = [];
      if (this.frequencyTimeout) {
        clearTimeout(this.frequencyTimeout);
      }
      this.frequencyTimeout = null;
      // this.progress = 0;
      // this.$emit("showLoading", { status: true, prop: this.progress });
      this.$emit("clearWaterMark");
      const insertResult = await this.AInsert({
        keyword: keyword || this.keyword,
        dataType: type || this.type
      });
      if (!insertResult.errorCode) {
        this.getFrequency(
          insertResult.data.hash,
          insertResult.data.isHasData,
          insertResult.data.searchTime,
          insertResult.data.isInit
        );
      } else {
        // this.showLoading(false,0);
        clearInterval(this.gettime);
        this.$emit("showLoading", { status: false, prop: 100 });
        this.isShowProgress = false;
        this.$notify({ message: insertResult.errorMess });
      }
    },
    async getFrequency(hash, isHasData, searchTime, isInit) {
      const result = await this.AFrequency({
        hash,
        dataType: this.type,
        isHasData,
        searchTime: searchTime,
        isInit: isInit
      });
      isInit = result.data.isInit;
      if (result.data) {
        //  this.showLoading(isHasData,result.data.progress);
        isHasData = result.data.isHasData;
        this.progress =
          result.data.result.rowCount > 0 ? 100 : result.data.progress;
        // this.$emit("showLoading", { status: true, prop: this.progress });
      }
      if (
        !result.errorCode &&
        (result.data.progress === 100 ||
          (result.data.result && result.data.result.rowCount > 0))
      ) {
        this.list = result.data.result.dataSource;
        this.isShowProgress = false;
        // this.showLoading(false,100);
        clearInterval(this.gettime);
        this.$emit("showLoading", { status: true, prop: 99 });
        setTimeout(() => {
          this.$emit("showLoading", { status: false, prop: this.progress });
        }, 500);
        this.$emit("wordok", false);
        if (result.data.progress !== 100 && result.data.isGather) {
          this.cycleFrequencyProgress(hash, isHasData, searchTime, isInit);
        }
      } else {
        if (result.errorCode) {
          this.$notify({ message: result.errorMess });
          clearInterval(this.gettime);
          this.$emit("showLoading", { status: true, prop: 100 });
          return;
        }
        this.frequencyTimeout = setTimeout(() => {
          this.getFrequency(hash, isHasData, searchTime, isInit);
        }, 500);
      }
    },
    getResultList() {
      return this.list
        .map(item => {
          return `${item.word}:${item.dataCount}`;
        })
        .join(",");
    },
    addData() {
      if (!this.word) {
        this.$notify({ message: "请输入词频关键词" });
        return;
      }
      if (this.dataCount <= 0) {
        this.$notify({ message: "近期媒体出现次数不能小于等于0" });
        return;
      }
      let data = { word: this.word, dataCount: this.dataCount };
      this.list.push(data);
      this.isShowAddDialog = false;
      this.word = "";
      this.dataCount = 1;
      //      this.list.sort((a,b)=>{
      //     return a.dataCount>b.dataCount;
      // });
      //this.list.reverse();
      this.sortByKey(this.list, "dataCount");
      this.$emit("editwords", true);
    },
    sortByKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? -1 : x < y ? 1 : 0;
      });
    },
    editData() {
      this.addButtonIsDisable = true;
      this.baklist = JSON.stringify(this.list);
      this.show = true;
      this.isShowSaveData = true;
    },
    deleteRow(index, rows) {
      //删除
      rows.splice(index, 1);

      //alert('list:'+this.list.length+"***bak"+this.baklist.length)
    },
    saveData() {
      if (!this.isCanSave) {
        this.$notify({ message: "输入内容不能为空" });
        return;
      }

      this.addButtonIsDisable = false;
      this.show = false;
      this.isShowSaveData = false;
      this.baklist = "";
      this.isCanSave = true;
      this.sortByKey(this.list, "dataCount");
      //修改词频后发送消息给父页面生成云图
      this.$emit("editwords", true);
    },
    cancel() {
      this.addButtonIsDisable = false;

      this.show = false;
      this.isShowSaveData = false;
      this.list = JSON.parse(this.baklist);
      this.isCanSave = true;
    },
    tableInputtBlur(inputValue) {
      if (inputValue == "") {
        this.isCanSave = false;
      } else {
        this.isCanSave = true;
      }
    },
    async cycleFrequencyProgress(hash, isHasData, searchTime, isInit) {
      const result = await this.AFrequency({
        hash,
        dataType: this.type,
        isHasData,
        searchTime: searchTime,
        isInit: isInit
      });

      if (result.data.progress !== 100) {
        isInit = result.data.isInit;
        isHasData = result.data.isHasData;
        setTimeout(() => {
          this.cycleFrequencyProgress(hash, isHasData, searchTime, isInit);
        }, 500);
      }
    }
  },
  destroyed() {
    clearTimeout(this.frequencyTimeout);
  }
};
</script>

<style scoped>
tr:hover {
  cursor: pointer;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
#easyInput .button-row {
  width: 196px;
  margin: 0 auto;
  padding-top: 20px;
}
.progress-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: rgba(255, 255, 255, 0.7);
}
.addkeywordButton {
  margin-bottom: 10px;
}
</style>
<style>
.addDailogClass .el-dialog__body {
  text-align: initial;
  padding: 0px 20px;
}
</style>

